import routes from './routes';

/*
 * The documentation, grouped by the product it documents.
 *
 * Docs get their own sidebar rather than an in-page tab strip, so the app has
 * one navigation model instead of three. A section per product means cargo and
 * health claims have somewhere to put their documentation when it is written.
 */

export interface DocsPage {
  key: string;
  label: string;
  path: string;
}

export interface DocsSection {
  key: string;
  label: string;
  icon: string;
  pages: DocsPage[];
}

export const DOCS_SECTIONS: DocsSection[] = [
  {
    key: 'endorsement',
    label: 'Endorsement',
    icon: 'pi-file',
    pages: [
      {
        key: 'workflow',
        label: 'Processing Workflow',
        path: `${routes.docs.index}/${routes.docs.workflow}`,
      },
      {
        key: 'statuses',
        label: 'Ticket Statuses',
        path: `${routes.docs.index}/${routes.docs.statuses}`,
      },
      {
        key: 'scenarios',
        label: 'Test Scenarios',
        path: `${routes.docs.index}/${routes.docs.scenarios}`,
      },
      {
        key: 'fields',
        label: 'Field Formats',
        path: `${routes.docs.index}/${routes.docs.fields}`,
      },
    ],
  },
  {
    key: 'cargoClaims',
    label: 'Cargo Claims',
    icon: 'pi-box',
    pages: [
      {
        key: 'cargo-overview',
        label: 'Claim Lifecycle',
        path: `${routes.docs.index}/${routes.docs.cargoClaims}`,
      },
      {
        key: 'cargo-statuses',
        label: 'Claim Statuses',
        path: `${routes.docs.index}/${routes.docs.cargoStatuses}`,
      },
      {
        key: 'cargo-fields',
        label: 'Claim Fields',
        path: `${routes.docs.index}/${routes.docs.cargoFields}`,
      },
    ],
  },
  {
    key: 'healthClaims',
    label: 'Health Claims',
    icon: 'pi-heart',
    pages: [
      {
        key: 'health-overview',
        label: 'Overview',
        path: `${routes.docs.index}/${routes.docs.healthClaims}`,
      },
    ],
  },
];

// Flat list, for anything that needs to match a path rather than render a menu.
export const DOCS_PAGES: DocsPage[] = DOCS_SECTIONS.flatMap(
  (section) => section.pages
);
